import DepartmentDTO from '@src/adapters/dto/department/DepartmentDTO';
import useCachedList from '../base/useCachedList';
import { useFindDepartmentsLazy } from './useFindDepartments';

type FindLazyResult = { departments: DepartmentDTO[] };

const useCachedDepartmentList = () => {
  return useCachedList<DepartmentDTO, FindLazyResult>(
    'departmentList',
    useFindDepartmentsLazy,
    'departments'
  );
};

export default useCachedDepartmentList;
